/**
 * Open a PDF in a new tab.
 *
 * The tab is opened *before* the PDF is fetched, inside the click handler:
 * one opened after an await counts as a popup and browsers block it. If it is
 * blocked anyway, the PDF is downloaded instead so the click never does
 * nothing. `fetchBlob` returns the PDF as a Blob; an error closes the blank
 * tab and is rethrown for the caller to report.
 */
export async function openPdfInNewTab(fetchBlob, filename = 'rapport.pdf') {
  const tab = window.open('', '_blank');
  try {
    const blob = await fetchBlob();
    const url = URL.createObjectURL(blob);
    if (tab) {
      tab.location = url;
    } else {
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      a.click();
    }
    // Revoked once the tab has had time to load it — revoking straight away
    // hands the new tab a dead URL.
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch (err) {
    if (tab) tab.close();
    throw err;
  }
}
